import { addClassName } from '@hc-frontend/core-utils-format';

import { CircularLoaderProps } from './circular-loader.types';

export function CircularLoader({ className }: CircularLoaderProps) {
  return (
    <div
      aria-label="Loading..."
      role="status"
      className={addClassName(
        'animate-spin size-24-24 border-2 border-gray-950 border-t-transparent rounded-full',
        className,
      )}
    />
  );
}
